import type { SerializedDockview } from 'dockview';
import { visitLayoutLeaves } from './layoutGridUtils';

/** Content component types (panel types) present in the layout (open tabs and panel definitions). */
export function getContentComponentsInLayout(layout: SerializedDockview): Set<string> {
  const components = new Set<string>();
  visitLayoutLeaves(layout, (_groupId, groupData) => {
    for (const viewId of groupData.views ?? []) {
      const component = layout.panels[viewId]?.contentComponent;
      if (component != null) {
        components.add(component);
      }
    }
  });
  for (const panel of Object.values(layout.panels)) {
    if (panel?.contentComponent != null) {
      components.add(panel.contentComponent);
    }
  }
  return components;
}
